import { render, staticRenderFns } from "./ProgramMedia.vue?vue&type=template&id=0b2b2d50&scoped=true&"
import script from "./ProgramMedia.vue?vue&type=script&lang=ts&"
export * from "./ProgramMedia.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramMedia.vue?vue&type=style&index=0&id=0b2b2d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b2d50",
  null
  
)

export default component.exports